import React, { Component } from 'react';
import Navigation from "../Navigation/Navigation";
import { Redirect } from 'react-router-dom';
import Footer from "../General/Footer";
import StarRatings from 'react-star-ratings';
import { Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/initialize';
import moment from 'moment';
import { createBooking } from '../../actions/createBookingActions';
import { getBookedDates } from '../../actions/getBookedDatesActions';
import { connect } from 'react-redux';
import Captain from "../../assets/badges/captain.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import { getChannel } from '../../actions/chatActions';
import { getOwner, getUserProfile } from '../../actions/userProfileActions';
import AlertComponent from '../Alert/alert';
import { getRide } from '../../actions/rideManagementActions';
import { Editor, EditorState, convertFromRaw } from 'draft-js';
import RiderContract from "../Legal/RiderContract";

export class RidePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            noProps: false,
            rideInfo: undefined,
            startDate: undefined,
            startFocused: false,
            endDate: undefined,
            endFocused: false,
            startValidated: true,
            bookedDates: [],
            redirectToChat: undefined,
            ownerInfos: undefined,
            descState: EditorState.createEmpty(),
            alert: {
                show: false,
                message: "",
                type: ""
            },
            show: false,
            userInfo: {}
        }
        this.onStartDateChange = this.onStartDateChange.bind(this);
        this.onStartFocusChange = this.onStartFocusChange.bind(this);
        this.onEndDateChange = this.onEndDateChange.bind(this);
        this.onEndFocusChange = this.onEndFocusChange.bind(this);
        this.outOfRange = this.outOfRange.bind(this);
        this.handleReserve = this.handleReserve.bind(this);
        this.dayBlocked = this.dayBlocked.bind(this);
        this.dateValidation = this.dateValidation.bind(this);
        this.gotoChat = this.gotoChat.bind(this);
        this.handleDismiss = this.handleDismiss.bind(this);
        this.setDescription = this.setDescription.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount() {
        if (this.props.location && this.props.location.state) {
            let rideInfo = this.props.location.state;
            this.initializeRide(rideInfo);
        }
        else {
            if (this.props.match && this.props.match.params) {
                getRide({ id: this.props.match.params.rideId }).then((rideInfo) => {
                    this.initializeRide(rideInfo.data);
                }).catch((err) => {
                    console.log("err: ", err);
                })
            }
            else {
                this.setState({
                    noProps: true
                })
            }
        }
    }

    initializeRide(rideInfo) {
        getBookedDates(rideInfo.objectId).then((res) => {
            let bookedDates = [];
            res.data.forEach((date) => {
                bookedDates.push(moment(date.split("\"").join("")));
            })
            this.setState({
                rideInfo,
                bookedDates
            }, () => {
                this.setDescription();
            })
        }).catch((err) => {
            console.log(err);
        })
        getOwner({ userId: rideInfo.ownerId }).then((res) => {
            this.setState({
                ownerInfos: res.data
            })
        }).catch((err) => {
            console.log(err);
        })
    }
    // Modal
    handleClose() {
        this.setState({ show: false });
    }

    handleShow() {
        if (this.props.user && this.props.user.token) {
            getUserProfile({ userId: this.props.user.userProfile.sub }, this.props.user.token).then((res) => {
                this.setState({
                    userInfo: res.data
                }, () => {
                    this.setState({
                        show: true
                    })
                });
            })
        }
        else {
            this.setState({
                alert: {
                    show: true,
                    message: "You need to login to your account to book a ride!",
                    type: "danger"
                }
            }, () => {
                window.scrollTo(0, 0);
            })
        }
    }

    handleDismiss() {
        this.setState({ alert: { ...this.state.alert, show: false } });
    }

    renderDetails(details) {
        let result = [];
        for (let key in details) {
            result.push(this.returnIcon(key, details));
        }
        return result
    }
    returnIcon(key, details) {
        switch (key) {
            case "make":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-toolbox"></i><span className="ridepage__feature__item__title"> Fabriquant </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "model":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-info-circle"></i><span className="ridepage__feature__item__title"> Modèle </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "motor":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-cogs"></i><span className="ridepage__feature__item__title"> Moteur </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "horsepower":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-horse"></i><span className="ridepage__feature__item__title"> Puissance </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "fuelType":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-gas-pump"></i><span className="ridepage__feature__item__title"> Type Carburant </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "year":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-calendar"></i><span className="ridepage__feature__item__title"> Année </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "width":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-arrows-alt-h"></i><span className="ridepage__feature__item__title"> Largeur </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "length":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-arrows-alt-v"></i><span className="ridepage__feature__item__title"> Longeur </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "sleepCapacity":
                if (details[key] === "0" || !details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-bed"></i><span className="ridepage__feature__item__title"> Couchettes </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "dockType":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-anchor"></i><span className="ridepage__feature__item__title"> Type de quai </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "constructionType":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-hammer"></i><span className="ridepage__feature__item__title"> Type de construction </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "weight":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-weight"></i><span className="ridepage__feature__item__title"> Poids (lb) </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "dryWeight":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-weight"></i><span className="ridepage__feature__item__title"> Poids à sèche (lb) </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "maxPassenger":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-users"></i><span className="ridepage__feature__item__title"> Capacité maximum de passagers </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "maxWeight":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-weight-hanging"></i><span className="ridepage__feature__item__title"> Capacité maximale de poids (lb) </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "nbPaddle":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-ship"></i><span className="ridepage__feature__item__title"> Nombre de pagaies </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "rvClass":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-bus"></i><span className="ridepage__feature__item__title"> Classe du VR </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "frameSize":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-bicycle"></i><span className="ridepage__feature__item__title"> Taille du cadre (po) </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "wheelSize":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-bicycle"></i><span className="ridepage__feature__item__title"> Taille des roues (po) </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "speeds":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-cog"></i><span className="ridepage__feature__item__title"> Vitesses </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "size":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-shoe-prints"></i><span className="ridepage__feature__item__title"> Grandeur </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "frameMaterial":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-info-circle"></i><span className="ridepage__feature__item__title"> Matériel du cadre </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "engineDisplacement":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-cogs"></i><span className="ridepage__feature__item__title"> Cylindrée (cc) </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "transmission":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-cogs"></i><span className="ridepage__feature__item__title"> Transmission </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "driveType":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-cogs"></i><span className="ridepage__feature__item__title"> Système d'entrainement </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "fuelCapacity":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-gas-pump"></i><span className="ridepage__feature__item__title"> Capacité d'essence </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "deckWidth":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-arrows-alt-h"></i><span className="ridepage__feature__item__title"> Largeur de la plance </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "groundClearance":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-arrows-alt-v"></i><span className="ridepage__feature__item__title"> Garde au sol (po) </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            case "deckLength":
                if (!details[key]) {
                    return ""
                }
                else {
                    return <div key={"details_" + key} className="ridepage__features__item"><i className="fas fa-arrows-alt-v"></i><span className="ridepage__feature__item__title"> Longeur de le planche </span> <span className="ridepage__feature__item__detail">{details[key]}</span></div>
                }
            default:
                return ""
        }
    }

    dateValidation(startDate, endDate) {
        let lowerDates = [];
        let valideDate = true;
        this.state.bookedDates.forEach((bookedDate) => {
            if (bookedDate.isBefore(endDate)) {
                lowerDates.push(bookedDate);
            }
        })
        lowerDates.forEach((lowerDate) => {
            if (lowerDate.isAfter(startDate)) {
                valideDate = false;
            }
        })
        return valideDate;
    }

    onStartDateChange(startDate) {
        if (this.state.endDate) {
            if (this.dateValidation(startDate, this.state.endDate)) {
                this.setState({
                    startDate
                }, () => {
                    if (startDate > this.state.endDate) {
                        this.setState({
                            endDate: undefined
                        })
                    }
                })
            }
        }
        else {
            this.setState({
                startDate
            })
        }
    }

    onStartFocusChange(data) {
        this.setState({
            startFocused: data.focused
        })
    }

    onEndDateChange(endDate) {
        if (this.state.startDate) {
            if (this.dateValidation(this.state.startDate, endDate)) {
                this.setState({
                    endDate
                })
            }
        }
        else {
            this.setState({
                endDate
            })
        }
    }

    onEndFocusChange(data) {
        this.setState({
            endFocused: data.focused
        })
    }

    dayBlocked(day) {
        return this.state.bookedDates.filter(d => d.isSame(day, 'day')).length > 0
    }

    outOfRange(day) {
        if (day.isBefore(moment().startOf("day")) || (this.state.startDate && day.isBefore(this.state.startDate))) {
            return true;
        }
        return false;
    }

    handleReserve() {
        this.handleClose();
        let date = this.state.startDate.clone();
        let dates = [];
        do {
            dates.push(date.clone());
            date.add(1, 'days');
        } while (!date.isAfter(this.state.endDate))
        createBooking({
            id: this.state.rideInfo.objectId,
            dates,
            userId: this.props.user.userProfile.sub
        }, this.props.user.token).then((res) => {
            if (res.data.id) {
                let stripe = window.Stripe('pk_test_wh8LmUPwjVvgAADRQXZ7tGM000V7hBJDgt');
                stripe.redirectToCheckout({
                    sessionId: res.data.id,
                }).then(function (result) {
                    this.setState({
                        alert: {
                            show: true,
                            message: "Error with the redirection to the checkout, please try again later.",
                            type: "danger"
                        }
                    }, () => {
                        window.scrollTo(0, 0);
                    })
                });
            }
            else {
                if (res.data === "reserved") {
                    this.setState({
                        alert: {
                            show: true,
                            message: "You have successfully made a reservation for your ride!",
                            type: "success"
                        },
                        startDate: undefined,
                        endDate: undefined
                    }, () => {
                        window.scrollTo(0, 0);
                        let rideInfo = this.state.rideInfo;
                        getBookedDates(rideInfo.objectId).then((res) => {
                            let bookedDates = [];
                            res.data.forEach((date) => {
                                bookedDates.push(moment(date.split("\"").join("")));
                            })
                            this.setState({
                                rideInfo,
                                bookedDates
                            })
                        }).catch((err) => {
                            console.log(err);
                        })
                    })
                }
                else {
                    this.setState({
                        alert: {
                            show: true,
                            message: "Error with the redirection to the checkout, please try again later.",
                            type: "danger"
                        }
                    }, () => {
                        window.scrollTo(0, 0);
                    })
                }
            }
        }).catch((err) => {
            let message = "You need to complete your profile to be able to book a ride!";
            if (err.response && err.response.data) {
                message = err.response.data;
            }
            this.setState({
                alert: {
                    show: true,
                    message: message,
                    type: "danger"
                }
            }, () => {
                window.scrollTo(0, 0);
            })
        });
    }

    gotoChat() {
        if (this.props.user && this.props.user.token) {
            if (this.props.user.userProfile.sub !== this.state.rideInfo.ownerId) {
                getChannel({
                    create: false,
                    userId: this.props.user.userProfile.sub,
                    otherUserId: this.state.rideInfo.ownerId
                }, this.props.user.token).then((res) => {
                    this.setState({
                        redirectToChat: res.data
                    })
                }).catch((err) => {
                    this.setState({
                        alert: {
                            show: true,
                            message: "You need to complete your profile to be able to chat!",
                            type: "danger"
                        }
                    }, () => {
                        window.scrollTo(0, 0);
                    })
                })
            }
            else {
                this.setState({
                    alert: {
                        show: true,
                        message: "You can't chat with yourself!",
                        type: "danger"
                    }
                }, () => {
                    window.scrollTo(0, 0);
                })
            }
        }
        else {
            this.setState({
                alert: {
                    show: true,
                    message: "You need to login to your account to chat!",
                    type: "danger"
                }
            }, () => {
                window.scrollTo(0, 0);
            })
        }
    }

    setDescription() {
        this.setState({
            descState: EditorState.createWithContent(convertFromRaw(JSON.parse(this.state.rideInfo.description)))
        })
    }

    render() {
        if (this.state.noProps) {
            return <Redirect to="/" />
        }
        if (this.state.redirectToChat) {
            return <Redirect to={{
                pathname: "/chat",
                state: {
                    select: this.state.redirectToChat
                }
            }} />
        }
        if (!this.state.rideInfo) {
            return (
                <div className="ridepage__main">
                    <Navigation auth={this.props.auth} />
                    <Footer />
                </div>
            )
        }
        let rideInfo = this.state.rideInfo;
        return (
            <div className="ridepage__main">
                <Navigation auth={this.props.auth} />
                <AlertComponent type={this.state.alert.type} message={this.state.alert.message} show={this.state.alert.show} handleDismiss={this.handleDismiss} />
                <div className="ridepage__hero"></div>
                <div className="ridepage__container">
                    <div className="ridepage__card__container">
                        <div className="ridepage__title">
                            {rideInfo.title} <br />
                            <span>{rideInfo.subtitle}</span>
                            <div className="ridepage__review">
                                {
                                    rideInfo.rating === 0
                                        ?
                                        <span>Non Classé</span>
                                        :
                                        <StarRatings
                                            rating={rideInfo.rating}
                                            starRatedColor="#0888be"
                                            starDimension="15px"
                                            starSpacing="0px"
                                        />
                                }
                            </div>
                        </div>
                        <div className="ridepage__top__grid">
                            <div className="ridepage__image">
                                <img src={rideInfo.images[0]} alt={rideInfo.title} />
                                {/* START - CAPTAIN PACKAGE? */}
                                {
                                    rideInfo.details.captain
                                        ?
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip>
                                                    <span>Forfait Capitaine Disponible</span>
                                                </Tooltip>
                                            }
                                        >
                                            <img src={Captain} className="ridepage__captain" />
                                        </OverlayTrigger>
                                        :
                                        null
                                }
                                {/* END - CAPTAIN PACKAGE? */}
                            </div>
                            <div className="ridepage__sidebar">
                                <div className="ridepage__price">
                                    ${rideInfo.priceD} par jour
                                </div>
                                <div className="ridepage__location">
                                    <i className="fas fa-map-marker-alt"></i> {rideInfo.city}
                                </div>
                                <div className="ridepage__date">
                                    <SingleDatePicker
                                        onDateChange={this.onStartDateChange}
                                        onFocusChange={this.onStartFocusChange}
                                        focused={this.state.startFocused}
                                        date={this.state.startDate}
                                        id="date_input"
                                        numberOfMonths={1}
                                        placeholder="Date Début"
                                        isDayBlocked={this.dayBlocked}
                                    />
                                    <SingleDatePicker
                                        onDateChange={this.onEndDateChange}
                                        onFocusChange={this.onEndFocusChange}
                                        focused={this.state.endFocused}
                                        date={this.state.endDate}
                                        id="date_input"
                                        numberOfMonths={1}
                                        placeholder="Date Fin"
                                        isDayBlocked={this.dayBlocked}
                                        isOutsideRange={this.outOfRange}
                                    />
                                    {/* https://github.com/airbnb/react-dates */}
                                    {/* http://airbnb.io/react-dates/?selectedKind=DateRangePicker%20%28DRP%29&selectedStory=default&full=0&addons=1&stories=1&panelRight=0&addonPanel=storybook%2Factions%2Factions-panel */}
                                </div>
                                <div className="ridepage__cta">
                                    <Button onClick={this.handleShow}>Réserver</Button>
                                </div>
                                {this.state.startDate && this.state.endDate && this.props.user.userProfile ?
                                    <RiderContract
                                        show={this.state.show}
                                        onHide={this.handleClose}
                                        onAccept={this.handleReserve}
                                        user={this.state.userInfo}
                                        start={this.state.startDate.format("L")}
                                        end={this.state.endDate.format("L")}
                                        nbDays={this.state.endDate.diff(this.state.startDate, 'days') + 1}
                                        priceD={rideInfo.priceD}
                                        email={this.props.user.userProfile.email}
                                    />
                                    : ""}
                            </div>
                        </div>
                        <div className="ridepage__bottom__grid">
                            <div className="ridepage__info">
                                <Form.Label className="createride__category__title ridepage__description__title">Description</Form.Label>
                                <div className="ridepage__description">
                                    <Editor editorState={this.state.descState} readOnly={true} />
                                </div>
                                <div className="ridepage__features">
                                    <Form.Label className="createride__category__title">Spécifications</Form.Label>
                                    <div className="ridepage__features__list">
                                        {this.renderDetails(rideInfo.details)}
                                    </div>
                                    <div className="ridepage__features__bools">
                                        {/* START - WASHROOMS? */}
                                        {
                                            rideInfo.details.washrooms
                                                ?
                                                <div>
                                                    <OverlayTrigger
                                                        overlay={
                                                            <Tooltip>
                                                                <span>Toilette Disponible</span>
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <i className="fas fa-toilet"></i>
                                                    </OverlayTrigger>
                                                </div>
                                                :
                                                null
                                        }
                                        {/* END - WASHROOMS? */}
                                        {/* START - TRAILER? */}
                                        {
                                            rideInfo.details.trailer
                                                ?
                                                <div>
                                                    <OverlayTrigger
                                                        overlay={
                                                            <Tooltip>
                                                                <span>Livraison Incluse</span>
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <i class="fas fa-shipping-fast"></i>
                                                    </OverlayTrigger>
                                                </div>
                                                :
                                                null
                                        }
                                        {/* END - TRAILER? */}
                                        {/* START - KITCHEN? */}
                                        {
                                            rideInfo.details.kitchen
                                                ?
                                                <div>
                                                    <OverlayTrigger
                                                        overlay={
                                                            <Tooltip>
                                                                <span>Cuisine</span>
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <i class="fas fa-utensils"></i>
                                                    </OverlayTrigger>
                                                </div>
                                                :
                                                null
                                        }
                                        {/* END - TRAILER? */}
                                    </div>
                                </div>
                                {/* <div className="ridepage__user">
                                    user
                                </div> */}
                            </div>
                            {this.state.ownerInfos ?
                                <div className="ridepage__booking__main">
                                    <hr />
                                    <Form.Label className="createride__category__title">Propriétaire</Form.Label>
                                    <div className="ridepage__booking__item">
                                        <img src={this.state.ownerInfos.image} /> {/* Picture of person Owner */}
                                        <div className="ridepage__booking__info">
                                            <div className="ridepage__booking__name">
                                                {this.state.ownerInfos.fullName}
                                            </div>
                                            <div className="ridepage__booking__dates">
                                                {this.state.ownerInfos.description}
                                            </div>
                                        </div>
                                        <div className="ridepage__booking__actions">
                                            <i className="fas fa-comment fa-2x" onClick={this.gotoChat}></i> {/* Chat */}
                                            {/*<i className="fas fa-ban"></i>  Cancel Booking */}
                                        </div>
                                    </div>
                                </div>
                                : ""}
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}

export default connect((state) => {
    return { user: state.reducerUser }
})(RidePage);